import { FormattedMessage } from 'react-intl'

import { Typography } from '@/shared/ui'

export const SourceOfFundsDescription = () => {
  return (
    <ul className="text-neutral-gray-600 list-disc pl-4">
      <li>
        <Typography>
          <FormattedMessage
            id="onboarding.companyActivity.sourceOfFunds.document.invoice"
            defaultMessage="Submit at least one invoice from the last three months that helps us prove your business' activity and transaction volume"
          />
        </Typography>
      </li>
      <li>
        <Typography>
          <FormattedMessage
            id="onboarding.companyActivity.sourceOfFunds.document.funding"
            defaultMessage="In the case of startups or newly formed companies, please provide the investor agreement and proof of the initial funding"
          />
        </Typography>
      </li>
    </ul>
  )
}
